module.exports = __webpack_public_path__ + "img/logo-full.5a9560be.png";